module.exports = __webpack_public_path__ + "static/img/Contactus.52d8304.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qingye/Contactus.png
// module id = IZDT
// module chunks = 1